import React from "react";
import SettingsSection from "../SettingsSection";
import RolePicker from "../RolePicker";

export default function RolesSection({
  roles,
  memberRole,
  setMemberRole,
  unverifiedRole,
  setUnverifiedRole,
  jailRole,
  setJailRole,
  autoRoleId,
  setAutoRoleId,
}) {
  return (
    <SettingsSection>
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "15px" }}
      >
        Auto-Role is optional and given on join when verification is off. After{" "}
        <code>/setup-verify</code>, Unverified is given on join and Member roles
        after the member verifies (in-Discord button or website OAuth). Configure
        the panel in Verification Panel, and roles here or via{" "}
        <code>/settings</code>.
      </p>

      <label className="input-label">AUTO-ROLE (ON JOIN, OPTIONAL)</label>
      <RolePicker
        roles={roles}
        value={autoRoleId}
        onChange={setAutoRoleId}
        emptyLabel="None (no role on join)"
        placeholder="Select auto-role…"
      />

      <label className="input-label" style={{ marginTop: "15px" }}>
        MEMBER ROLES (AFTER VERIFY)
      </label>
      <RolePicker
        roles={roles}
        value={memberRole}
        onChange={setMemberRole}
        multiple
        emptyLabel="None"
        placeholder="Select member roles…"
      />
      <p
        className="help-text"
        style={{ fontSize: "0.75rem", marginTop: "8px", opacity: 0.6 }}
      >
        Selected: {memberRole.length} role(s)
      </p>

      <label className="input-label" style={{ marginTop: "15px" }}>
        UNVERIFIED ROLE
      </label>
      <RolePicker
        roles={roles}
        value={unverifiedRole}
        onChange={setUnverifiedRole}
        emptyLabel="None (no gatekeeping)"
        placeholder="Select unverified role…"
      />

      <label className="input-label">JAIL ROLE</label>
      <RolePicker
        roles={roles}
        value={jailRole}
        onChange={setJailRole}
        emptyLabel="None"
        placeholder="Select jail role…"
      />
    </SettingsSection>
  );
}
